import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectWishlistCount } from '../../store/slices/wishlistSlice';
import { HeartIcon } from '../icons/Icons';
import { theme } from '../../config/theme';

const WishlistIcon = () => {
  const navigate = useNavigate();
  const count = useSelector(selectWishlistCount);

  const buttonStyles = {
    position: 'relative',
    padding: theme.spacing.sm,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: 'none',
    transition: theme.transitions.base,
  };

  const badgeStyles = {
    position: 'absolute',
    top: '2px',
    right: '2px',
    backgroundColor: theme.colors.error,
    color: theme.colors.white,
    borderRadius: theme.borderRadius.full,
    padding: '2px 6px',
    fontSize: theme.typography.fontSize.xs,
    fontWeight: theme.typography.fontWeight.bold,
    minWidth: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <button 
      style={buttonStyles} 
      onClick={() => navigate('/wishlist')}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = theme.colors.gray[50];
        e.currentTarget.style.borderRadius = theme.borderRadius.md;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
      aria-label={`Wishlist (${count} items)`}
    >
      <HeartIcon size={24} color={theme.colors.text.primary} />
      {count > 0 && (
        <span style={badgeStyles}>{count}</span>
      )}
    </button>
  );
};

export default WishlistIcon;